<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack('dateForm')">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Create a Shift</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button @click="goNext('dateForm')" :disabled="formsData.dateForm.disabled">
                <span>Next</span>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <el-form class="schedule_form" :model="formsData.dateForm" :rules="formsData.dateForm.rules"
                :ref="el => formsData.dateForm.ref = el" :label-position="'top'" @submit.prevent="goNext('dateForm')">
                <!-- <div class="form_text page_padding_top">
                    <div class="title">
                        Shift days & hours
                    </div>
                    <div class="text_note">
                        Select working days of the vacant role and input hours for the shifts
                    </div>
            
                </div> -->

                <div class="auth-header">
                    <div class="auth-heading">
                        <h1>Shift days & hours</h1>
                        <p class="auth-subtext">Select working days of the vacant role and
                            input hours for the shifts.</p>
                    </div>
                </div>
                <!-- <el-form-item v-if="formFieldsDays.length > 1"
                    label="Do you want this job to be booked by single Locum?" class="font-weight-bold">
                    <el-switch v-model="isBlockShift" size="default" class="mb-2" active-text="Yes"
                        inactive-text="No" />
                </el-form-item> -->
                <el-form-item v-if="formFieldsDays.length > 1"
                    :label="`Do you want this shift to be booked by same ${ $filters.systemLocumName(false, false) }?`"  class="font-weight-bold">
                    <el-select v-model="isBlockShift" popper-class="normal-select" placeholder="Select an option" size="default" class="mb-2">
                        <el-option label="Yes" :value="true"></el-option>
                        <el-option label="No" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <template v-for="(formFieldName, index) in formFieldsDays" :key="formFieldName">

                    <div class="single-shift-time">
                        <el-form-item class="schedule_form_checkbox">
                            <div class="schedule_day_select_checkbox">
                                <el-checkbox :disabled="index == 0" v-model="formsData.dateForm[formFieldName].active" class="date-checkbox"
                                    @change="() => { checkFormValidation('dateForm', true, formFieldName); setFormValidation('dateForm', formFieldName, !formsData.dateForm[formFieldName].active) }">
                                    <!-- {{
                                    $moment(formFieldName, 'DD/MM/YYYY').format('DD/MM/YYYY') }} {{
                                    $moment(formFieldName,
                                    'DD/MM/YYYY').format('dddd') }}  -->
                                    <span class="weekday">{{ $moment(formFieldName, 'DD/MM/YYYY').format('dddd') }}</span>
                                    <span class="date">{{ $moment(formFieldName, 'DD/MM/YYYY').format('MMM DD YYYY') }}</span>
                                </el-checkbox>
                                <el-checkbox class="cursor button-all-copy"
                                    v-model="formsData.dateForm[formFieldName].copyTime"
                                    @change="copyTimeToAllDay(index, formFieldName)"
                                    v-if="checkForMoreThanOneAndFirstDay(formFieldName)">Copy to all {{
                                    $filters.pluralize($moment(formFieldName, 'DD/MM/YYYY').format('dddd')) }}</el-checkbox>
                            </div>
                        </el-form-item>
                        <el-form-item class="schedule_form_time" :prop="formFieldName"
                            v-if="formsData.dateForm[formFieldName].active">
                            <ion-item>
                                <ion-datetime v-model="formsData.dateForm[formFieldName].value.timeStart"
                                    display-format="h:mm A" minute-values="0,15,30,45" placeholder="Start Time"
                                    @ionChange="checkFormValidation('dateForm', true, formFieldName)"></ion-datetime>
                            </ion-item>
                            <span class="schedule_form_to mr-2 ml-2">to </span>
                            <ion-item>
                                <ion-datetime v-model="formsData.dateForm[formFieldName].value.timeEnd"
                                    display-format="h:mm A" minute-values="0,15,30,45" placeholder="End Time"
                                    @ionChange="checkFormValidation('dateForm', true, formFieldName)"></ion-datetime>
                            </ion-item>
                        </el-form-item>
                    </div>

                </template>
            </el-form>
            <el-button class="primary w-full mt-auto" @click="goNext('dateForm')"
                :disabled="formsData.dateForm.disabled">
                Next
            </el-button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'

    import {
        onMounted,
        inject,
        ref
    } from 'vue';

    import {
        addIcons
    } from 'ionicons'
    import {
        arrowBackOutline
    } from 'ionicons/icons'
    addIcons({
        'arrow-back-outline': arrowBackOutline
    })
    import {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        IonTitle,
        IonDatetime,
        IonItem,
    } from '@ionic/vue';

    import {
        useStore
    } from 'vuex'
    import {
        useRouter,
    } from 'vue-router'
    import formHooks from '@/hooks/form/form'
    import formValidate from '@/hooks/form/validate/validate'

    export default {
        components: {
            IonToolbar,
            IonButton,
            IonButtons,
            IonIcon,
            IonTitle,
            IonDatetime,
            IonItem,
        },
        directives: {
        },
        setup() {
            const $store = useStore()
            const $router = useRouter()
            const setPageClassGlobal = inject('setPageClassGlobal');

            const jobCreatePageData = $store.getters.getJobCreatePageData;
          const setformFieldsDays = () => {
            let dates = [];
            dates = jobCreatePageData.dates
            return dates;
          };

          const isBlockShift = ref(false);
          const formFieldsDays = setformFieldsDays();
          const subscription = ref(1);
            let fields = {};

            const timeStartDefault = moment('8:00 AM', ["h:mm A"]).format();
            const timeEndDefault = moment('5:00 PM', ["h:mm A"]).format();
            const checkboxValue = true;
            const schedule = jobCreatePageData.schedule;
            const blockShiftOld = jobCreatePageData.isBlockShift;

            if (blockShiftOld) {
                isBlockShift['value'] = blockShiftOld ? true : false;
            }
            // console.log("This is old Block Shift", jobCreatePageData)
            // console.log("This is old Block Shift", isBlockShiftOld)


            formFieldsDays.forEach((elementDay, i) => {
                let timeStart = timeStartDefault;
                let timeEnd = timeEndDefault;
                let active = checkboxValue;
                if (schedule && schedule[elementDay]) {
                    if (schedule[elementDay].timeStart) {
                        timeStart = schedule[elementDay].timeStart;
                        timeEnd = schedule[elementDay].timeEnd;
                        active = true
                    } else {
                        active = false
                    }
                }

                

                if (i == 0) {
                    active = true
                }

                fields[elementDay] = {
                    value: {
                        timeStart: timeStart,
                        timeEnd: timeEnd,
                        date: elementDay
                    },
                    active: active,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'timeRange', callback, setFormValidation);
                        },
                    }, {
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'currentTimeLater', callback, setFormValidation);
                        },
                    }],

                }
            });

            const formsDataArray = {
                dateForm: fields,
            };


            const goBack = (formName) => {
                let formValues = getFormValues(formName);
                formFieldsDays.forEach((elementDay) => {
                    if (!formValues[elementDay]) {
                        formValues[elementDay] = {}
                    }
                });
                $store.dispatch('setJobCreatePageData', {
                    schedule: formValues
                });
                // if(subscription.value==1){
                //     $router.push({
                //         name: "job_create_date"
                //     })
                // }else{
                    $router.push({
                        name: "job_create_date",
                    });
                // }
                
            };

            const goNext = (formName) => {
                formsRefs[formName].value.validate((valid) => {
                    if (valid) {
                        let formValues = getFormValues(formName);
                        formFieldsDays.forEach((elementDay) => {
                            if (!formValues[elementDay]) {
                                formValues[elementDay] = {}
                            }
                        });
                        $store.dispatch('setJobCreatePageData', {
                            schedule: formValues
                        });

                        $store.dispatch('setJobCreatePageData', {
                            isBlockShift: isBlockShift
                        });
                        $router.push({
                            name: 'job_create_rate',
                        })
                    } else {
                        setFormValidation(formName, false, false);
                        console.log('error submit!!');
                        return false;
                    }
                });
            };

            const copyTimeToAllDay = (index, selectedDate) => {
                let formValues = getFormValues('dateForm');
                let timeStart = formValues[formFieldsDays[index]].timeStart;
                let timeEnd = formValues[formFieldsDays[index]].timeEnd;
                let selectedDay = moment(selectedDate, 'DD/MM/YYYY').format('dddd');
                let copyTime = formsData.dateForm[selectedDate].copyTime;
                formFieldsDays.forEach((elementDate) => {
                    let elementDay = moment(elementDate, 'DD/MM/YYYY').format('dddd');
                    if(selectedDay == elementDay && copyTime) {
                        formValues[elementDate].timeStart = timeStart;
                        formValues[elementDate].timeEnd = timeEnd;
                    } 
                    if(selectedDay == elementDay && selectedDate != elementDate && !copyTime) {
                        formValues[elementDate].timeStart = moment('8:00 AM', ["h:mm A"]).format();
                        formValues[elementDate].timeEnd = moment('5:00 PM', ["h:mm A"]).format();
                    }           
                });
            };

            const checkForMoreThanOneAndFirstDay = (date) => {
                let count = 0;
                let day = moment(date, 'DD/MM/YYYY').format('dddd');
                let isFirstDay = false;
                let encountered = false;
                formFieldsDays.forEach((elementDate) => {
                   let elementDay = moment(elementDate, 'DD/MM/YYYY').format('dddd');
                     if(day == elementDay) {
                          count++;
                          if (!encountered) {
                            encountered = true;
                            if(date == elementDate) {
                                isFirstDay = true;
                            }
                        }
                     }
                }); 
                return count > 1 && isFirstDay;
            }


            onMounted(() => {
                setPageClassGlobal('global_job_create_page');
                setFormRefs();
                checkFormValidation('dateForm', true);
            });

            const {
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                getFormValues,
                setFormRefs,
                formsData,
                formsRefs,
            } = formHooks(formsDataArray);

            return {
                formsData,
                formFieldsDays,
                onFormMaskAccept,
                checkFormValidation,
                setFormValidation,
                goBack,
                goNext,
                isBlockShift,
                subscription,
                copyTimeToAllDay,
                checkForMoreThanOneAndFirstDay
            }
        },
    }
</script>